import { Divider } from '@components/core-ui/Divider';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { GetBillingAccountResponseDto } from 'app/API';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  billingAccount: GetBillingAccountResponseDto;
  onSuccess?: () => void;
};

type PlanSelection = {
  subscriptionProductId: string;
  planName: string;
  price: number;
  freeSeats: number;
};

export const AddSubscription = ({ billingAccount, onSuccess }: TProps) => {
  const { openModal, closeModal } = useModalContext();

  const onClick = () => {
    openModal(ModalNamesEnum.AdminChooseASOneSubscriptionModal, {
      billingAccountId: billingAccount.id,
      onSuccess: ({ subscriptionProductId, planName, price, freeSeats }: PlanSelection) => {
        closeModal();
        if (onSuccess) {
          onSuccess();

          openModal(ModalNamesEnum.AdminConfirmSubscription, {
            billingAccountId: billingAccount.id,
            subscriptionProductId,
            planName,
            freeSeats,
            onSuccess,
            price: Number(price),
          });
        }
      },
    });
  };

  if (billingAccount.subscriptions?.length) {
    return null;
    // return (
    //   <Wrapper onClick={onClick}>
    //     <div className="title">Upgrade</div>
    //     <Divider className="divider" />
    //     <div className="text">Expand your access: add subscription to your account</div>
    //   </Wrapper>
    // );
  }

  return (
    <Wrapper onClick={onClick}>
      <div className="title">AutoScriptOne</div>
      <Divider className="divider" />
      <div className="text">RealTime Reporter Capture Tool</div>
      <div className="button">+ Add Subscription</div>
    </Wrapper>
  );
};
